import React, { useEffect } from 'react';
import styled from "@emotion/styled";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { i18n, mq, setCustomer, setFlowType, setProgressBarPercentage, useAppDispatch } from 'src/common';
import { Card, CustomerForm, HtmlText, HtmlTextLink, Text } from 'src/components';

const TitleStyle = styled(Text)({
  marginBottom: 16
})

const CardStyle = styled(Card)(
  mq({
    padding: ['16px', '16px', "24px", "24px", "40px"],
    marginBottom: 16
  })
)

const htmlTextLinks: Array<HtmlTextLink> = [
  { value: 'form', link: 'https://kompare.hr/obrazac-za-prituzbe/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.form') },
  { value: 'mail', link: 'mailto:szop@kompare.hr', translation: 'szop@kompare.hr' },
  { value: 'here', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.here') },
  { value: 'privacyPolicy', link: 'https://kompare.hr/informacije-o-koristenju-osobnih-podataka/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.privacyPolicy') },
  { value: 'terms', link: 'https://kompare.hr/uvjeti-koristenja/', translation: i18n.t('pages.customerPage.htmlTextLinkTranslations.terms') },
];

const CustomerContractNowPage = () => {
  const { birthDate } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setProgressBarPercentage(20));
    dispatch(setFlowType('web'));
  }, []);

  useEffect(() => {
    dispatch(setCustomer({ birthDate, age: dayjs().diff(dayjs(birthDate), 'year') }));
  }, [birthDate]);

  return (
    <>
      <CardStyle title={<TitleStyle type="large" bold>{i18n.t('pages.customerContractNowPage.title')}</TitleStyle>}>
        <CustomerForm
          customer={{ birthDate }}
          formItems={['fullName', 'email', 'phoneNumber', 'hasPolicy']}
          labels={{
            fullName: i18n.t('pages.customerContractNowPage.fullNameLabel'),
            email: i18n.t('pages.customerContractNowPage.emailLabel'),
            phoneNumber: i18n.t('pages.customerContractNowPage.phoneLabel'),
          }}
        />
      </CardStyle>
      <HtmlText i18nKey="pages.customerPage.gdprConsentWithParams" links={htmlTextLinks} />
    </>
  );
}

export default CustomerContractNowPage;
